import React, { useEffect } from 'react';
import Snackbar from '@mui/material/Snackbar';
import { Button } from '@material-ui/core';
import NotificationsIcon from '@mui/icons-material/Notifications';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CloseIcon from '@mui/icons-material/Close';
import './Custom-Snackbar.scss';
import notificationTone from '../../assets/notificationTone.mp3';
import { Howl } from 'howler';

const CustomSnackbar = (props) => {
  const { notification, onCloseNotification, onClickViewNotification, notificationNdx } = props;

 useEffect(() => {
    let sound;
    if (notification?.open) {
      sound = new Howl({
        src: [notificationTone],
        html5: true,
      });
      sound.play();
    }
    return () => {
      if (sound) {
        sound.stop();
      }
    };
  }, [notification]); 

  const handleClose = () => {
    onCloseNotification(notification, notificationNdx);
  };

  const onClickButton = () => {
    onClickViewNotification(notification, notificationNdx);
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={notification?.open}
      onClose={handleClose}
      autoHideDuration={12000}
    >
      <div className='custom-snackbar d-flex'>
        <div className='notification'>
          <NotificationsIcon className='notification-icon' />
          <FiberManualRecordIcon className='notification-icon-dot' />
        </div>
        <div className='details'>
          <p className='details-title'>{notification?.title}</p>
          <p className='details-description'>{notification?.description}</p>
        </div>
        <Button
          variant='contained'
          color='primary'
          type='button'
          className='btn-order'
          endIcon={<ArrowForwardIosIcon className='btn-order-icon' />}
          onClick={onClickButton}
        >
          {notification?.buttonTitle}
        </Button>
        <Button
          variant='outlined'
          type='button'
          className='btn-close'
          onClick={handleClose}
        >
          <CloseIcon />
        </Button>
      </div>
    </Snackbar>
  );
};

export default CustomSnackbar;
